"use strict";

// @links: https://developer.mozilla.org/en-US/docs/web/javascript/reference/statements/export
export {justifybutton, checkIsMobiles, checkIsLandscape};

function justifybutton(target, turn)
{
    var array = [];

    if (turn == 'on') {
        if (window.matchMedia('(max-width: 576px)').matches) {
            $(target + ' .minw-60').each(function (index, el) {
                $(this).addClass('minw-60-0');
            });
        } else {
            $(target + ' .minw-60').each(function (index, el) {
                $(this).removeClass('minw-60-0');
            });

            $(target + ' .jb').each(function (index, el) {
                array.push($(this).width());
            });
            var maxValue = Math.max.apply(Math, array);
            // $(target + ' .jb').width(maxValue);
            $(target + ' .jb').css('width', maxValue + 'px');
        }
    } else {
        $(target + ' .jb').each(function (index, el) {
            array.push($(this).width());
        });
        var maxValue = Math.max.apply(Math, array);
        $(target + ' .jb').width(maxValue + 2);
        // $(target + ' .jb').css('width', maxValue+'px');
    }
}

/**
 * Check size less than tablet size.
 *
 * @returns {boolean}
 */
function checkIsMobiles()
{
    let isTablet = false;

    if (window.matchMedia('(max-width: 992px)').matches) {
        isTablet = true;
    }

    return isTablet;
}

/**
 * Check is mobile and landscape
 *
 * @returns {boolean}
 */
function checkIsLandscape()
{
    let isLand = false;

    if (window.matchMedia("(orientation: landscape)").matches) {
        isLand = checkIsMobiles();
    }

    return isLand;
}